import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search } from "@air/next-icons";
import { memo, useCallback } from "react";
import { SearchCommandItem } from "~/components/SearchCommand/SearchCommandItem";
export const SearchCommandSuggestionListItem = /*#__PURE__*/ memo((param)=>{
    let { suggestion, onSelect: _onSelect } = param;
    const onSelect = useCallback(()=>_onSelect(suggestion), [
        suggestion,
        _onSelect
    ]);
    return /*#__PURE__*/ _jsxs(SearchCommandItem, {
        "data-type": "suggestion",
        onSelect: onSelect,
        value: suggestion,
        children: [
            /*#__PURE__*/ _jsx(Search, {
                className: "w-4 shrink-0 text-grey-10"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "truncate text-14 font-medium",
                children: suggestion
            })
        ]
    });
});
SearchCommandSuggestionListItem.displayName = "SearchCommandSuggestionListItem";
